import React from 'react';
import { motion } from 'framer-motion';
import { VehicleCard } from './VehicleCard';
import { useLanguage } from '../lib/i18n';
import { vehicles } from '../lib/vehicles';
interface VehicleGridProps {
  onVehicleClick: (slug: string) => void;
}
export function VehicleGrid({
  onVehicleClick
}: VehicleGridProps) {
  const {
    t
  } = useLanguage();
  return <section id="vozy" className="py-24 md:py-32 bg-[#0a0a0a]" data-id="element-254">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-255">
        {/* Section Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-256">
          <span className="text-[#c8a96e] text-sm font-semibold tracking-widest uppercase mb-4 block" data-id="element-257">
            {t('vehicles.sectionLabel')}
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white" data-id="element-258">
            {t('vehicles.sectionTitle')}
          </h2>
        </motion.div>

        {/* Vehicle Grid - 2 columns on desktop */}
        <div className="max-w-3xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-259">
          {vehicles.map(vehicle => <VehicleCard key={vehicle.slug} image={vehicle.hasPhotos ? vehicle.images[0] : ''} name={vehicle.name} year={vehicle.year} mileage={vehicle.mileage} power={vehicle.cardPower} price={vehicle.price} hasPhotos={vehicle.hasPhotos} onClick={() => onVehicleClick(vehicle.slug)} data-id="element-260" />)}
        </div>
      </div>
    </section>;
}